import { useState } from "react";
import useGenerateTrackingTemplatesAndWorkflows
  from "@babackapp/private-api-client/client/use-generate-tracking-templates-and-workflows";
import { GenerateDefaultTemplatesRequestDto } from "@babackapp/private-api-client/generated/schema";
import useCurrentShopSuspense from "./use-current-shop-suspense";
import { useTemplatesEditorRouting } from "../context/templates-editor-routing-context";


export type UseTemplateActionsOptions = {
  onTemplateCreated?: () => void;
};


export function useTemplateActions(options: UseTemplateActionsOptions = {}) {
  const { onTemplateCreated } = options;
  const { openTemplate } = useTemplatesEditorRouting();
  const { data: shop } = useCurrentShopSuspense();

  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isStatusSelectionModalOpen, setIsStatusSelectionModalOpen] =
    useState(false);

  const { mutateAsync: generateTemplates, isPending: isGenerating } =
    useGenerateTrackingTemplatesAndWorkflows(shop.id);

  const handleGenerateDefaultTemplates = async (
    selectedStatuses: GenerateDefaultTemplatesRequestDto["trackingStatuses"],
    enableWorkflows: boolean,
  ) => {
    await generateTemplates({
      requestBody: {
        trackingStatuses: selectedStatuses,
        enableWorkflows,
      },
    });
    setIsStatusSelectionModalOpen(false);
    onTemplateCreated?.();
  };

  const navigateToTemplate = (templateId: string) => {
    openTemplate?.(templateId);
  };

  const openCreateModal = () => setIsCreateModalOpen(true);
  const openStatusSelectionModal = () => setIsStatusSelectionModalOpen(true);

  return {
    shop,
    isCreateModalOpen,
    setIsCreateModalOpen,
    isStatusSelectionModalOpen,
    setIsStatusSelectionModalOpen,
    isGenerating,
    handleGenerateDefaultTemplates,
    navigateToTemplate,
    openCreateModal,
    openStatusSelectionModal,
  };
}
